<template>
  <!-- TODO:restore [min-width: 1350px;] -->
  <div
    id="contentWrapper"
    class="full flex-col"
    style="overflow-y: auto; min-width: 1350px"
  >
  <HeaderPart :is-show-menu="!isShowMenu" :is-show-logo="true"></HeaderPart>

    <!-- 页面容器 -->
    <div
      id="innerContent"
      class="container body-content flex-col flex-expend"
      style="overflow-y: auto; overflow-x: hidden"
    >
      <div
        :class="['bar__route-map', '', routeMapClass]"
        :style="routeMapStyle"
        v-if="!isMainPage && !isShowMenu"
      >
        <div class="bar__route-map--source inline-block">
          <el-breadcrumb>
            <svg-icon class="mr-6" icon="home"></svg-icon>
            <el-breadcrumb-item v-for="item in parts" :key="item">
              <span class="no-redirect">{{ item }}</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <router-view class="page-container"></router-view>
    </div>
    <!-- foot -->
    <FootPart v-if="isMainPage"></FootPart>
  </div>
</template>

<script>
import HeaderPart from "./components/Header";
import FootPart from "./components/Foot";
import config from "@/configs/pathConfigures";
import { mapGetters } from "vuex";

export default {
  components: {
    HeaderPart,
    FootPart,
  },
  props: {
    routeMapClass: String,
    routeMapStyle: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["customeRoadMap"]),
    isShowMenu() {
      let showMenu = false;
      let browsePath = config.prefixUrl + "/book/browse/:id";
      this.$route.matched.$$each((match) => {
        if (match.path === browsePath) {
          showMenu = true;
        }
      });
      return showMenu;
    },
    isMainPage() {
      console.log("#-# isMainPage:", this.$route.matched,this.$route);
      return this.$route.matched.$$all((match) => {
        return [config.prefixUrl, config.prefixUrl + "/home"].$$any(
          (path) => path == match.path
        );
      });
    },
    parts() {
      if (this.customeRoadMap) {
        return this.customeRoadMap;
      } else {
        let result = [
          ...this.$route.matched
            .filter((item) => item)
            .$$select((r) => r.meta.title)
            .filter((item) => item),
        ].$$flat();

        if (result.length < 1 || result[0] != "首页") {
          result = [ ...result];
        }
        console.log("#-# route changed:", result);
        return result;
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
#contentWrapper {
  background-color: rgb(228, 227, 239);
}

#innerContent {
  padding: 0 20px 20px;
  position: relative;
}

.page-container {
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  background-color: white;
  padding: 12px;
}

.page-container__paddingless {
  padding: 0;
}

.bar__route-map {
  color: #666666;
  display: flex;
  align-items: center;
  height: 50px;
  position: static;
  padding-left: 5px;

  > * {
    vertical-align: middle;
  }

  .bar__route-map--source {
    .el-breadcrumb {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
    }
    .el-breadcrumb__item {
      position: absolute;
      display: contents;
    }
  }
}
</style>
